<template>
  <div>
    <step-title :navItems="navItems" :index="0" :step="0" />

    <div class="container pt-5 pb-5" :class="{ 'bg-white': isEmpty }">
      <empty-page :title="$t('without_class_list')" :description="$t('without_list_of_established_classes')" v-if="isEmpty" />

      <div class="row" v-else>
        <div class="col-sm-8 offset-sm-2">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between p-0 rounded mb-3"
              v-for="(item, index) in list" :key="index"
              v-on:mouseover="pointer = item.id"
              v-on:mouseout="pointer = null">
              <div class="w-100 text-left p-3" style="line-height: 150%;">
                {{ item.name }}<br>{{$t('generated_time')}}：{{ item.createTime }}
              </div>

              <div class="d-flex align-items-center justify-content-end" style="width: 430px;">
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="d-none">
                  <span class="pr-3 text-right" v-if="pointer !== item.id">{{ $tc('student', item.studentCount,{count: item.studentCount}) }} <br>{{$t('teacher')}}：{{ item.teacherName }}</span>
                </transition>

                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="d-none">
                  <div class="w-100 text-right" v-if="pointer === item.id">
                    <icon-button name="setting" :alt="$t('edit_class')" @click.native="$router.push('/group-mgr/edit/' + item.id)" />
                    <icon-button name="single_add" :alt="$t('add_single_student')" @click.native="$router.push('/group-mgr/group/' + item.id + '/student/add')" />
                    <icon-button name="excel" :alt="$t('import_students')" @click.native="$router.push('/group-mgr/group/' + item.id + '/student/excel')" />
                    <icon-button name="delete" :alt="$t('delete')" @click.native="remove(item.id)" />
                  </div>
                </transition>
              </div>
            </li>
          </ul>

          <pagination class="mt-5" :current="pageIndex" :total="pageCount" v-on:page="updatePage" />
        </div>
      </div>

      <div class="row mt-5 d-flex">
        <button class="btn btn-success btn-block w-50 mx-auto" @click.stop.prevent="$router.push('/group-mgr/add/group')">{{$t('create_class')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../store/api'
import Pagination from '../../components/Pagination'
import EmptyPage from './EmptyPage'
import 'animate.css'
import IconButton from './IconButton'
import swal from 'bootstrap-sweetalert'
import StepTitle from './StepTitle'

export default {

  name: 'TeachingGroup',

  components: {
    Pagination,
    EmptyPage,
    IconButton,
    StepTitle
  },

  data () {
    return {
      navItems: [this.$t('add_or_select_list'), this.$t('input_name'), this.$t('select_student'), this.$t('_finish')],
      list: [],
      pageIndex: 1,
      pageCount: 0,
      pointer: null
    }
  },

  computed: {
    isEmpty () {
      return this.list.length === 0
    }
  },

  mounted () {
    this.groupId = this.$route.params.groupId
    this.getList()
  },

  methods: {
    async getList (page) {
      page = page || 1
      const { data } = await api.get('/GroupMgr/TeachingGroups', { params: { pageIndex: page } })

      this.list = data.data
      this.pageIndex = data.pageIndex
      this.pageCount = data.pageCount
      console.log(data)
    },

    updatePage (page) {
      this.pageIndex = page
    },

    remove (id) {
      let self = this

      swal({
        title: this.$t('deleting_confirm'),
        text: this.$t('note'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.$t('want_delete'),
        cancelButtonText: this.$t('cancel'),
        closeOnConfirm: false
      },
      async function () {
        const { data } = await api.delete('/GroupMgr/TeachingGroups/' + id)

        if (data.status === 'OK') {
          self.getList()
          swal(this.$t('successfully_deleted'), this.$t('class_deleted_successfully'), 'success')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-group-item {
    &:hover {
      box-shadow: 0 0 8px #a1a1a1;
      transition: box-shadow 0.2s ease-in-out;
    }
  }
</style>


// WEBPACK FOOTER //
// TeachingGroup.vue?ef2ee394